import { AxiosResponse } from "axios";
import API from "../api";

import { Symbol } from "../models/symbol";

const ROUTE_NAME = "symbols";

const SymbolsService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<any[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async update(id: number, symbol: Symbol): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, symbol);
  },
  async create(symbol: Symbol): Promise<AxiosResponse<Symbol>> {
    return await API.post(`/${ROUTE_NAME}`, symbol);
  },
};

export default SymbolsService;
